import { Component } from '@angular/core';

@Component({
  selector: 'app-investor-meetings',
  templateUrl: './investor-meetings.component.html',
})
export class InvestorMeetingsComponent {

  constructor() {


    window.location.href = "https://calendly.com/pk-cabbagepay/30min";


  }

}
